import { render, staticRenderFns } from "./PongGame1.vue?vue&type=template&id=cce075c4&scoped=true&"
import script from "./PongGame1.vue?vue&type=script&lang=js&"
export * from "./PongGame1.vue?vue&type=script&lang=js&"
import style0 from "./PongGame1.vue?vue&type=style&index=0&id=cce075c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce075c4",
  null
  
)

export default component.exports